import { request } from './http';

const createAdminReservation = (reservation) => request('createAdminReservation', {
  body: reservation,
  authRequired: true
});

const createWalkIn = (walkIn) => request('createWalkIn', {
  body: walkIn,
  authRequired: true
});

const seatWalkIn = (walkInId) => request('seatWalkIn', {
  body: { walkInId },
  authRequired: true
});

const cancelWalkIn = (walkInId, reason = '') => request('cancelWalkIn', {
  body: { walkInId, reason },
  authRequired: true
});

const confirmReservation = (reservationId) => request('confirmReservation', {
  body: { reservationId },
  authRequired: true
});

const resendReservationConfirmation = (reservationId) => request('resendReservationConfirmation', {
  body: { reservationId },
  authRequired: true
});

const denyReservation = (reservationId) => request('denyReservation', {
  body: { reservationId },
  authRequired: true
});

const cancelReservation = (reservationId, reason) => request('adminCancelReservation', {
  body: { reservationId, reason },
  authRequired: true
});

const updateReservation = (reservation) => request('updateReservation', {
  body: reservation,
  authRequired: true
});

const scanReservationQr = (reservationId) => request('scanReservationQr', {
  body: { reservationId },
  authRequired: true
});

const assignReservationTable = (reservationId, tableId) => request('assignReservationTable', {
  body: { reservationId, tableId },
  authRequired: true
});

const releaseReservationTable = (reservationId) => request('releaseReservationTable', {
  body: { reservationId },
  authRequired: true
});

const assignReservationGroup = (reservationId, groupId) => request('assignReservationGroup', {
  body: { reservationId, groupId },
  authRequired: true
});

const releaseReservationGroup = (reservationId) => request('releaseReservationGroup', {
  body: { reservationId },
  authRequired: true
});

const assignReservationWaiter = (reservationId, waiterId) => request('assignReservationWaiter', {
  body: { reservationId, waiterId },
  authRequired: true
});

const setReservationManualTable = (reservationId, tableNumber) => request('setReservationManualTable', {
  body: { reservationId, tableNumber },
  authRequired: true
});

const deleteReservation = (reservationId) => request('deleteReservation', {
  body: { reservationId },
  authRequired: true
});

const markDepositApplied = (reservationId) => request('markDepositApplied', {
  body: { reservationId },
  authRequired: true
});

const cleanOldReservations = () => request('cleanOldReservations', {
  body: {},
  authRequired: true
});

const purgePendingReservations = (names = []) => request('purgePendingReservations', {
  body: names.length ? { includePast: false, names } : { includePast: false },
  authRequired: true
});

const sendReservationMessage = (reservationId, content, sender = 'admin') => request('sendReservationMessage', {
  body: { reservationId, content, sender },
  authRequired: true
});

export {
  createAdminReservation,
  createWalkIn,
  seatWalkIn,
  cancelWalkIn,
  confirmReservation,
  resendReservationConfirmation,
  denyReservation,
  cancelReservation,
  updateReservation,
  scanReservationQr,
  assignReservationTable,
  releaseReservationTable,
  assignReservationGroup,
  releaseReservationGroup,
  assignReservationWaiter,
  setReservationManualTable,
  deleteReservation,
  markDepositApplied,
  cleanOldReservations,
  purgePendingReservations,
  sendReservationMessage
};
